import {Injectable} from '@angular/core';
import {Feature} from '@catcore/services/feature/feature';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {FeatureGgwImplementationCreateInfo} from '@catmodules/models/feature-ggw-implementations/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FeatureGgwImplementationsService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-ggw-implementations', service);
  }

  create(item: FeatureGgwImplementationCreateInfo): Observable<any> {
    return this.queryAll()
      .post({
        model: item.ggwImplementation._links.self.href,
        unit_type: item.featureUnit._links.self.href,
        name: item.name,
      })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  extractGgwDevicesFor(ggwImpl: any): any[] {
    const lookupKey = 'ggw_device_types';
    return this.extractDataFromProperty(ggwImpl, lookupKey);
  }

  private extractDataFromProperty(ggwImpl: any, lookupKey: string, propertyName = '_links'): any[] {
    let items: any[] = [];
    if (Object.keys(ggwImpl).includes(propertyName)) {
      const linkedResourceKeys = Object.keys(ggwImpl[propertyName]);
      if (linkedResourceKeys.includes(lookupKey)) {
        items = ggwImpl[propertyName][lookupKey];
      }
    }
    return items;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-ggw-implementations/services/feature-ggw-implementations.service.ts